export default __webpack_public_path__ + "static/img_screen_1400-b4b93db45447b4fc124460028153373e.jpg";